import heroVideo from "../assets/video/Tabkhtna-hero-background.mp4";
import CtaButton from "./CtaButton";

function Hero() {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/tabkhatna-1.apk";
    link.download = "tabkhatna.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="home" className="relative w-full overflow-hidden aspect-video min-h-[260px] max-[600px]:aspect-[4/3] max-[600px]:min-h-[280px] max-[380px]:aspect-[3/4] max-[380px]:min-h-[300px] font-[Cairo]">

      {/* الفيديو */}
      <video
        className="absolute inset-0 w-full h-full object-cover z-0"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
        متصفحك ما بيدعم الفيديو
      </video>

      {/* الطبقة السوداء الشفافة */}
      <div className="absolute inset-0 z-[1] bg-black/30" />

      {/* محتوى الهيرو */}
      <div
        dir="rtl"
        className="absolute z-[2] inset-0 flex flex-col items-center justify-center text-center px-5"
      >

        {/* عنوان الهيرو */}
        <h1
          className="
            w-full
            max-w-[920px]
            text-white
            font-[Cairo]
            font-extrabold
            text-[72px]
            leading-[1.15]
            tracking-[-1.5px]
            mb-[16px]
            max-[900px]:text-[52px]
            max-[900px]:tracking-[-0.8px]
            max-[600px]:text-[34px]
            max-[600px]:leading-[1.25]
            max-[600px]:mb-[12px]
            max-[380px]:text-[28px]
          "
        >
          اطلب طبختك بمكونات جاهزة
        </h1>

        {/* الوصف */}
        <p
          className="
            w-full
            max-w-[560px]
            text-white
            font-[Cairo]
            font-normal
            text-[18px]
            leading-[1.8]
            mb-[22px]
            max-[900px]:text-[15px]
            max-[600px]:text-[13px]
            max-[600px]:leading-[1.7]
            max-[600px]:mb-[15px]
            max-[380px]:text-[12px]
          "
        >
          وجبة جاهزة، أكل سريع، أو مكونات طبخة كاملة بالكميات المناسبة. اطلب اللي بدك ياه ويوصلك لباب البيت.
        </p>

        {/* الزر */}
        <CtaButton onClick={handleDownload} size="lg" />

      </div>

    </section>
  );
}

export default Hero;